import {
  Component,
  OnInit,
  ViewChild
} from "@angular/core";
import { EstimateExternalService } from "../../master-services/estimate-external/estimate-external.service";
import { IEstimateExternal } from "../../master-models/estimate-external.model";
import { IEstimateExternalDetails } from "../../master-models/estimate-external-details.model";
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CustomerExternalService } from "../../master-services/customer-external/customer-external.service";
import { CountryService } from "../../master-services/countries/country.service";
import { ICustomerExternal } from "../../master-models/customer-external.model";
import { ICountry } from "../../master-models/country.model";
import swal from "sweetalert2";
import { ModalBasicComponent } from "../../shared/modal-basic/modal-basic.component";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-master-estimate-customer",
  templateUrl: "./master-estimate-customer-ext.component.html",
  styleUrls: [
    "./master-estimate-customer-ext.component.scss",
    "../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class MasterEstimateCustomerExtComponent implements OnInit {
  estimate: IEstimateExternal = null;
  details: IEstimateExternalDetails[] = [];
  customers: ICustomerExternal[] = [];
  countries: ICountry[] = [];
  username = localStorage.getItem('username') || '';
  userId = localStorage.getItem('userid') || 0;
  currentlyDate = Date.now();
  estimateForm: FormGroup;
  estimateDetailForm: FormGroup;
  showCreateItem = false;
  isEditingEstimate = false;
  isEditingEstimateDetail = false;
  detailToEdit: IEstimateExternalDetails = null;

  @ViewChild('modalRegisterItemExt') modalRegisterItemExt: ModalBasicComponent;

  constructor(
    private estimateExternalSrv: EstimateExternalService,
    private customerExternalSrv: CustomerExternalService,
    private countrySrv: CountryService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit() {
    this.generateEstimateForm();
    this.generateEstimateDetailForm();

    const id = this.route.snapshot.queryParamMap.get('id');
    if (id) {
      this.getEstimateExternalData(Number(id));
      this.showCreateItem = true;
      this.estimateForm.disable();
    }

    this.getAllCountries();
    this.getAllCustomersExt();
  }

  generateEstimateForm() {
    this.estimateForm = this.fb.group({
      customer_id: [null, [
        Validators.required
      ]],
      payment_method: [null, [
        this.requiredAllowZero
      ]],
      guaranty: [null, [
        this.requiredAllowZero
      ]],
      validity: [null, [
        this.requiredAllowZero
      ]],
      observation: [''],
    });
  }
  
  generateEstimateDetailForm() {
    this.estimateDetailForm = this.fb.group({
      code: ['', [
        Validators.required
      ]],
      description: ['', [
        Validators.required
      ]],
      quantity: [null, [
        Validators.required
      ]],
      unit_cost: [null, [
        Validators.required
      ]],
    });
  }

  assignCurrentlyEstimateValues() {
    if (!this.estimate) return;
    
    this.estimateForm.patchValue({
      customer_id: this.estimate.customer_id,
      payment_method: this.estimate.payment_method,
      guaranty: this.estimate.guaranty,
      validity: this.estimate.validity,
      observation: this.estimate.observation || '',
    });
  }
  
  assignCurrentlyEstimateDetailValues(detail: IEstimateExternalDetails = null) {
    if (!detail) return;
    
    this.estimateDetailForm.patchValue({
      code: detail.code,
      description: detail.description,
      quantity: detail.quantity,
      unit_cost: detail.unit_cost,
    });
  }
  
  createEstimate() {
    if (this.estimateForm.invalid) {
      swal({
        title: "Informacion incompleta",
        text: "Ingrese todos los valores requeridos (*)",
        type: "error",
      });
      return;
    }

    swal({
      title: "Guardando información ...",
      allowOutsideClick: false,
    });

    const newEstimate = this.estimateForm.value;
    newEstimate.elaborate_user_id = this.userId;
    this.estimateExternalSrv.createEstimateExternal(newEstimate)
      .subscribe({
        next: res => {
          this.estimate = res.estimate_external;
          this.showCreateItem = true;
          swal.close();

          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { id: this.estimate.id },
          }).then(() => {
            this.getEstimateExternalData(this.estimate.id);
            this.showCreateItem = true;
            this.estimateForm.disable();
          });
        },
        error: e => {
          swal.close();
          swal({
            title: 'Error al guardar',
            text: 'No se pudo completar el proceso. Intente nuevamente.',
            type: 'error',
          });
        }
      });
  }

  createEstimateDetail() {
    if (this.estimateDetailForm.invalid) {
      swal({
        title: "Informacion incompleta",
        text: "Ingrese todos los valores requeridos (*)",
        type: "error",
      });
      return;
    }

    swal({
      title: "Guardando información ...",
      allowOutsideClick: false,
    });

    const newEstimateDetail = this.estimateDetailForm.value;
    newEstimateDetail.estimate_external_id = this.estimate.id;
    this.estimateExternalSrv.createEstimateExternalDetails(newEstimateDetail)
      .subscribe({
        next: res => {
          this.getEstimateExternalData(this.estimate.id);
          this.modalRegisterItemExt.hide();
          swal.close();
        },
        error: e => {
          swal.close();
          swal({
            title: 'Error al guardar',
            text: 'No se pudo completar el proceso. Intente nuevamente.',
            type: 'error',
          });
        }
      });
  }

  toggleIsEditingEstimate() {
    this.isEditingEstimate = !this.isEditingEstimate;
    if (!this.isEditingEstimate) {
      this.assignCurrentlyEstimateValues();
      this.estimateForm.disable();
      return;
    }
    
    this.estimateForm.enable();
  }

  updateEstimate() {
    if (this.estimateForm.invalid) {
      swal({
        title: "Informacion incompleta",
        text: "Ingrese todos los valores requeridos (*)",
        type: "error",
      });
      return;
    }

    swal({
      title: "Guardando información ...",
      allowOutsideClick: false,
    });

    const estimateUpdated = {
      ...this.estimate,
      ...this.estimateForm.value
    };
    this.estimateExternalSrv.updateEstimateExternal(this.estimate.id, estimateUpdated)
      .subscribe({
        next: res => {
          this.getEstimateExternalData(this.estimate.id);
          this.showCreateItem = true;
          this.toggleIsEditingEstimate();
          swal.close();
        },
        error: e => {
          swal.close();
          swal({
            title: 'Error al guardar',
            text: 'No se pudo completar el proceso. Intente nuevamente.',
            type: 'error',
          });
        }
      });
  }

  updateEstimateDetail() {
    if (this.estimateDetailForm.invalid) {
      swal({
        title: "Informacion incompleta",
        text: "Ingrese todos los valores requeridos (*)",
        type: "error",
      });
      return;
    }

    swal({
      title: "Guardando información ...",
      allowOutsideClick: false,
    });

    const estimateDetailUpdated = {
      ...this.detailToEdit,
      ...this.estimateDetailForm.value
    };
    this.estimateExternalSrv.updateEstimateExternalDetails(this.detailToEdit.id, estimateDetailUpdated)
      .subscribe({
        next: res => {
          this.getEstimateExternalData(this.estimate.id);
          this.toggleModalEstimateDetail();
          swal.close();
        },
        error: e => {
          swal.close();
          swal({
            title: 'Error al guardar',
            text: 'No se pudo completar el proceso. Intente nuevamente.',
            type: 'error',
          });
        }
      });
  }

  deleteEstimateDetail(id: number) {
    swal({
      title: "Eliminando información ...",
      allowOutsideClick: false,
    });
    this.estimateExternalSrv.deleteEstimateExternalDetails(id)
      .subscribe(res => {
        this.getEstimateExternalData(this.estimate.id);
        swal.close();
      });
  }

  toggleModalEstimateDetail(estimateDetail: IEstimateExternalDetails = null) {
    if (this.modalRegisterItemExt.visible) {
      this.detailToEdit = null;
      this.estimateDetailForm.reset();
      this.modalRegisterItemExt.hide();
      return;
    }

    if (estimateDetail) {
      this.isEditingEstimateDetail = true;
      this.detailToEdit = estimateDetail;
    } else {
      this.isEditingEstimateDetail = false;
    }

    this.assignCurrentlyEstimateDetailValues(estimateDetail);
    this.modalRegisterItemExt.show();
  }

  getEstimateExternalData(id: number) {
    this.estimateExternalSrv.getEstimateExternal(id)
      .subscribe(res => {
        if (res && res.success && res.data) {
          this.estimate = res.data;
          this.details = res.data.details || [];
          this.assignCurrentlyEstimateValues();
        } else {
          this.estimate = null;
          this.details = [];
        }
      });
  }

  getAllCustomersExt() {
    this.customerExternalSrv.getCustomerExternalList()
      .subscribe(data => {
        this.customers = data.data;
      });
  }

  getAllCountries() {
    this.countrySrv.getCountriesList()
      .subscribe(data => {
        this.countries = data.data;
      })
  }

  requiredAllowZero(control: AbstractControl) {
    return control.value !== null && control.value !== undefined ? null : { required: true };
  }
}



// WEBPACK FOOTER //
// ./src/app/master/master-estimate-customer-ext/master-estimate-customer-ext.component.ts